import AdsClickOutlinedIcon from "@mui/icons-material/AdsClickOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";

import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined";
import WarningOutlinedIcon from "@mui/icons-material/WarningOutlined";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";

import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import { WebsiteVertical } from "./galaxy";
import { OptionObj } from "@/types/interfaces/common";

// app related
export const HEADER_HEIGHT = 64;
export const HEADER_HEIGHT_MOBILE = 80;
export const NAVBAR_HEIGHT = 54;
export const NAVBAR_HEIGHT_MOBILE = 40;
export const BREADCRUMBSBAR_HEIGHT = 48;
export const S3_ENDPOINT = `https://hub.service.prod.useast1.ttand.com/api/v1/agents/s3Upload`;
export const TTAND_GALAXY_BUCKET = "ttand-galaxy";
export const TTAND_IMGIX_URL = `https://ttand.imgix.net`;
export const TTAND_S3_IMGIX_URL = `https://s3.amazonaws.com/ttand-galaxy/imgix`;
export const IMG_NOT_AVAILABLE_URL = `${TTAND_S3_IMGIX_URL}/not-available.jpg`;

export const KAYAKO_BASE_SSO_AUTH_URL = `https://ttand.kayako.com/Base/SSO/JWT`;

export const DEFAULT_ITINERARY_BG =
  "https://s3.amazonaws.com/ttand/uploads/common/travel-world-monuments-1741876128310.jpg";
export const DEFAULT_IDEA_IMAGE = "https://s3.amazonaws.com/ttand/uploads/common/images-1715586945015.jpeg";

export const TTAND_BRAND = "The Travel Agent Next Door";

export const LUXE_BY_TTAND_BRAND = "LUXE by TTAND";

export const LUXE_EMAIL_DOMAIN = "luxebyttand.com";

export const SLIDERS_CONTENT_ID = "5a91c69579ad665024949b37";

export const ADMIN_WEBSITE = {
  activeStatus: true,
  agencyName: "Admin",
  host: "admin.thetravelagentnextdoor.com",
  verticalId: WebsiteVertical.STANDARD,
  id: 0,
  province: "",
};
export const ADMIN_ROUTE_PREFIX = "/admin";

export const STANDARD_DOMAIN = "thetravelagentnextdoor.com";

export const SUPPLIER_PROGRAMS = ["LUXE", "DMC", "US Gateways"];

export const SUPPLIER_PROGRAM_OPTIONS = SUPPLIER_PROGRAMS.map((program) => ({
  label: program,
  value: program,
}));

// pagination
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZES = [5, 10, 20, 50, 100];

// prospects client linq
export const PROSPECTS_CLIENT_LINQ_PROFILE_TYPES = [
  { label: "Client", value: "0" },
  { label: "Passenger", value: "1" },
];

export const PROSPECTS_CLIENT_LINQ_ACCOUNT_TYPES = [
  { label: "Leisure", value: "0" },
  { label: "Corporate", value: "1" },
  { label: "Group", value: "3" },
  { label: "Prospect", value: "4" },
  { label: "Lead", value: "6" },
];

// marketing
export const MARKETING_ITEMS = [
  {
    codeId: 211,
    codeType: 0,
    category: "TTAND",
    description: "E-Exotic Escapes",
    code: "",
    ranking: 1,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 209,
    codeType: 0,
    category: "TTAND",
    description: "E-Enchanting Europe",
    code: "",
    ranking: 2,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 207,
    codeType: 0,
    category: "TTAND",
    description: "E-Culinary Delights",
    code: "",
    ranking: 3,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 205,
    codeType: 0,
    category: "TTAND",
    description: "E-Inspiring Journeys",
    code: "",
    ranking: 4,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 377,
    codeType: 0,
    category: "TTAND",
    description: "E-Ocean & River Cruises",
    code: "",
    ranking: 5,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 527,
    codeType: 0,
    category: "TTAND",
    description: "E-Family Adventures",
    code: "",
    ranking: 6,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 212,
    codeType: 0,
    category: "TTAND",
    description: "E-Sun Destinations",
    code: "",
    ranking: 7,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 208,
    codeType: 0,
    category: "TTAND",
    description: "E-Vacations of a Lifetime",
    code: "",
    ranking: 8,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
  {
    codeId: 210,
    codeType: 0,
    category: "TTAND",
    description: "E-World of Savings",
    code: "",
    ranking: 9,
    flags: 0,
    clientCodes: null,
    action: 3,
  },
];

// posts
export const PAGE_TYPES = [
  { label: "Default Page / Hosted Tour", value: "DEFAULT" },
  {
    label: "Wedding Group",
    value: "GROUP",
  },
];

// event types

// tailwind 100 and 500
export const EVENT_COLORS = {
  "Select All": {
    bgColor: "#d1fae5", // emerald
    borderColor: "#10b981",
  },
  "TTAND Event": {
    bgColor: "#ffedd5", // orange
    borderColor: "#f97316",
  },
  "TTAND Training": {
    bgColor: "#e0f2fe", // sky blue
    borderColor: "#0ea5e9",
  },
  "Supplier Event": {
    bgColor: "#ccfbf1", // teal
    borderColor: "#14b8a6",
  },
  "Supplier Training": {
    bgColor: "#dbeafe", // blue
    borderColor: "#3b82f6",
  },
  "Supplier Product Launch": {
    bgColor: "#e0e7ff", // indigo
    borderColor: "#6366f1",
  },
  "Tourist Boards Event": {
    bgColor: "#cffafe", // cyan
    borderColor: "#06b6d4",
  },
  Other: {
    bgColor: "#fae8ff", // fuschia
    borderColor: "#d946ef",
  },
} as const;

export const EVENT_MODES = [
  {
    label: "International",
    value: "INTL",
  },
  {
    label: "Online / Webinar",
    value: "ONLINE",
  },
  {
    label: "Unknown",
    value: "UNKNOWN",
  },
  {
    label: "Alberta",
    value: "AB",
  },
  {
    label: "British Columbia",
    value: "BC",
  },
  {
    label: "Manitoba",
    value: "MB",
  },
  {
    label: "New Brunswick",
    value: "NB",
  },
  {
    label: "Newfoundland and Labrador",
    value: "NL",
  },
  {
    label: "Northwest Territories",
    value: "NT",
  },
  {
    label: "Nova Scotia",
    value: "NS",
  },
  {
    label: "Nunavut",
    value: "NU",
  },
  {
    label: "Ontario",
    value: "ON",
  },
  {
    label: "Prince Edward Island",
    value: "PE",
  },
  {
    label: "Quebec",
    value: "QC",
  },
  {
    label: "Saskatchewan",
    value: "SK",
  },
  {
    label: "Yukon",
    value: "YT",
  },
];

// export const EVENT_COLORS = {
//   "Supplier Event": {
//     bgColor: "#bfdbfe",
//     borderColor: "#2563eb",
//     checkboxColor: "#2563eb", // yellow 400
//   },
//   "Training Event": {
//     bgColor: "#bbf7d0",
//     borderColor: "#16a34a",
//     checkboxColor: "#16a34a", // fuschia 500
//   },
//   "TTAND Event": {
//     bgColor: "#fed7aa",
//     borderColor: "#ea580c",
//     checkboxColor: "#ea580c", // orange 600
//   },
//   Conference: {
//     bgColor: "#e0f2fe",
//     borderColor: "#0369a1",
//     checkboxColor: "#0ea5e9", // sky 500
//   },
//   "Tourist Boards Event": {
//     bgColor: "#e9d5ff",
//     borderColor: "#9333ea",
//     checkboxColor: "#9333ea", // violet 700
//   },
//   "Town Hall": {
//     bgColor: "#dbeafe",
//     borderColor: "#1d4ed8",
//     checkboxColor: "#1d4ed8", // blue 700
//   },
//   "Product & Brochure Launch": {
//     bgColor: "#dcfce7",
//     borderColor: "#15803d",
//     checkboxColor: "#15803d", // green 700
//   },
//   "Road Show": {
//     bgColor: "#ccfbf1",
//     borderColor: "#0f766e",
//     checkboxColor: "#5eead4", // teal 300
//   },
//   "Open House": {
//     bgColor: "#ecfccb",
//     borderColor: "#4d7c0f",
//     checkboxColor: "#a3e635", // lime 400
//   },
//   "Website Video": {
//     bgColor: "#f1f5f9",
//     borderColor: "#334155",
//     checkboxColor: "#475569", // slate 600
//   },
//   Other: {
//     bgColor: "#ffe4e6",
//     borderColor: "#be123c",
//     checkboxColor: "#be123c", // rose 700
//   },
//   undefined: {
//     bgColor: "#ffe4e6",
//     borderColor: "#be123c",
//     checkboxColor: "#be123c", // rose 700
//   },
// } as const;

export const EVENT_REGIONS = {
  "Supplier Event": {
    bgColor: "#bfdbfe",
    borderColor: "#2563eb",
    checkboxColor: "#2563eb", // yellow 400
  },
  "Training Event": {
    bgColor: "#bbf7d0",
    borderColor: "#16a34a",
    checkboxColor: "#16a34a", // fuschia 500
  },
  "TTAND Event": {
    bgColor: "#fed7aa",
    borderColor: "#ea580c",
    checkboxColor: "#ea580c", // orange 600
  },
  Conference: {
    bgColor: "#e0f2fe",
    borderColor: "#0369a1",
    checkboxColor: "#0ea5e9", // sky 500
  },
  "Tourist Boards Event": {
    bgColor: "#e9d5ff",
    borderColor: "#9333ea",
    checkboxColor: "#9333ea", // violet 700
  },
  "Town Hall": {
    bgColor: "#dbeafe",
    borderColor: "#1d4ed8",
    checkboxColor: "#1d4ed8", // blue 700
  },
  "Product & Brochure Launch": {
    bgColor: "#dcfce7",
    borderColor: "#15803d",
    checkboxColor: "#15803d", // green 700
  },
  "Road Show": {
    bgColor: "#ccfbf1",
    borderColor: "#0f766e",
    checkboxColor: "#5eead4", // teal 300
  },
  "Open House": {
    bgColor: "#ecfccb",
    borderColor: "#4d7c0f",
    checkboxColor: "#a3e635", // lime 400
  },
  "Website Video": {
    bgColor: "#f1f5f9",
    borderColor: "#334155",
    checkboxColor: "#475569", // slate 600
  },
  Other: {
    bgColor: "#ffe4e6",
    borderColor: "#be123c",
    checkboxColor: "#be123c", // rose 700
  },
  undefined: {
    bgColor: "#ffe4e6",
    borderColor: "#be123c",
    checkboxColor: "#be123c", // rose 700
  },
} as const;

export const EMAIL_STATUSES = {
  SENT: "SENT",
  DRAFT: "DRAFT",
};

export const EMAIL_TRANSACTION_STATUSES = {
  SENT: "sent",
  DRAFT: "draft",
  FAILED: "failed",
};

export const EMAIL_CAMPAIGN_STAT_FILTERS = [
  // {
  //   label: "All",
  //   value: "all",
  //   Icon: SendOutlinedIcon,
  //   infoText: "These include all the events",
  // },
  {
    label: "Send",
    value: "send",
    Icon: CheckOutlinedIcon,
    infoText: "The call to Server was successful and Server will attempt to deliver the email.",
  },
  {
    label: "Delivery",
    value: "delivery",
    Icon: LocalShippingOutlinedIcon,
    infoText: "Server successfully delivered the email to the recipient's mail server.",
  },
  {
    label: "Open",
    value: "open",
    Icon: MarkEmailReadOutlinedIcon,
    infoText: "The recipient received the message and opened it in his or her email client.",
  },
  {
    label: "Click",
    value: "click",
    Icon: AdsClickOutlinedIcon,
    infoText: "The recipient clicked one or more links contained in the email.",
  },
  {
    label: "Soft Bounce",
    value: "softBounce",
    Icon: LiveHelpOutlinedIcon,
    infoText:
      "Soft bounces are only included when Server fails to deliver the email after retrying for a period of time.",
  },
  {
    label: "Hard Bounce",
    value: "hardBounce",
    Icon: WarningOutlinedIcon,
    infoText: "The recipient's mail server permanently rejected the email.",
  },
  {
    label: "Complaint",
    value: "complaint",
    Icon: SentimentDissatisfiedOutlinedIcon,
    infoText: "The email was successfully delivered to the recipient. The recipient marked the email as spam.",
  },
  {
    label: "Reject",
    value: "reject",
    Icon: CancelOutlinedIcon,
    infoText:
      "Server accepted the email, determined that it contained a virus, and rejected it. Server didn't attempt to deliver the email to the recipient's mail server.",
  },
  {
    label: "Unsubscribe",
    value: "unsubscribe",
    Icon: UnsubscribeOutlinedIcon,
    infoText: "",
  },
];

export const UNSUBSCRIBED_CLIENTS_STAT_FILTERS = [
  {
    label: "All",
    value: "all",
    Icon: SendOutlinedIcon,
    infoText: "These include all three events, hard-bounce, soft-bounce, unsubscribe",
  },
  {
    label: "Hard Bounce",
    value: "hardBounce",
    Icon: WarningOutlinedIcon,
    infoText:
      "The recipient's mail server permanently rejected the email. This email address is most probably invalid.",
  },
  {
    label: "Complaint",
    value: "complaint",
    Icon: SentimentDissatisfiedOutlinedIcon,
    infoText: "The email was successfully delivered to the recipient. The recipient marked the email as spam.",
  },
  {
    label: "Unsubscribe",
    value: "unsubscribe",
    Icon: UnsubscribeOutlinedIcon,
    infoText:
      "The email was successfully delivered to the recipient. The recipient chose to unsubscribe from the email list.",
  },
];

// export const EMAIL_MARKETING_CODES = [
//   {
//     name: "Ocean & River Cruises",
//     description: "Cruise and escorted travel options",
//     code: 377,
//     serial: 1,
//   },
//   {
//     name: "Exotic Escapes",
//     description: "Asia, Australia, Middle East, South America and more",
//     code: 211,
//     serial: 2,
//   },
//   {
//     name: "Enchanting Europe",
//     description: "Options for Europe",
//     code: 209,
//     serial: 3,
//   },
//   {
//     name: "Culinary Delights",
//     description: "Food, wine and beer lovers",
//     code: 207,
//     serial: 4,
//   },
//   {
//     name: "Inspiring Journeys",
//     description: "Inspirational travel ideas",
//     code: 205,
//     serial: 5,
//   },
//   {
//     name: "Sun Destinations",
//     description: "Sun-kissed experiences",
//     code: 212,
//     serial: 7,
//   },
//   {
//     name: "Vacations of a Lifetime",
//     description: "Bucket list travel options",
//     code: 208,
//     serial: 8,
//   },
//   {
//     name: "World of Savings",
//     description: "Current travel deals",
//     code: 210,
//     serial: 9,
//   },
//   {
//     name: "Family Adventures",
//     description: "Perfect gateways for all family members",
//     code: 527,
//     serial: 6,
//   },
// ];

export const TTAND_LOGO_URL = "https://ttand-galaxy.s3.amazonaws.com/imgix/ttand-logo-custom-tagline-1.png";
export const TTAND_LOGO_STICKY = "https://ttand-galaxy.s3.amazonaws.com/imgix/logo_sticky.png";

export const ADMIN_TYPE = "admin";
export const AGENT_TYPE = "agent";
export const AGENCY_TYPE = "agency";

export const ADD_FORM_TYPE = "ADD";
export const EDIT_FORM_TYPE = "EDIT";

export const ADVERTISEMENT_TYPES = [
  {
    label: "Default",
    value: "DEFAULT",
  },
  {
    label: "Preferred",
    value: "PREFERRED",
  },
  {
    label: "Approved",
    value: "APPROVED",
  },
];

export const AGENT_TYPES = {
  primary: "PA",
  associate: "AA",
};

export const EMAIL_TEMPLATE_TYPE = {
  marketingEmail: {
    label: "Marketing Email",
    value: "MARKETING",
  },
  customEmail: {
    label: "Custom Email",
    value: "CUSTOM",
  },
};

export const SETTINGS_GALAXY = {
  homePagePreferences: "HOME_PAGE_PREFERENCES",
  thirdParty: "THIRD_PARTY",
  experiencesConfig: "EXPERIENCES_CONFIG",
  agencyContent: "AGENCY_CONTENT",
  bannerImages: "BANNER_IMAGES",
  bannerVideo: "BANNER_VIDEO_SETTINGS",
  blogsConfig: "BLOGS_CONFIG",
  suppliersConfig: "SUPPLIERS_CONFIG",
  emailNotifications: "EMAIL_NOTIFICATIONS",
  navConfig: "NAV_CONFIG",
  customNavConfig: "CUSTOM_NAV_CONFIG",
  offersConfig: "OFFERS_CONFIG",
  themeConfig: "THEME_CONFIG",
  assets: "ASSETS",
  associateDetails: "ASSOCIATE_DETAILS",
  agentOrder: "AGENT_ORDER",
  magazines: "MAGAZINES",
  vcePages: "VCE_PAGE",
  bookingEngines: "BOOKING_ENGINES",
  websiteSections: "WEBSITE_SECTIONS",
  itcBookingEngine: "ITC_BOOKING_ENGINE",
  aibeHome: "AIBE_HOME",
  aibeCommon: "AIBE_COMMON",
  aibeIntegrations: "AIBE_INTEGRATIONS",
  hide: "HIDE_CONTENT",
  contentPreferences: "CONTENT_PREFERENCES",
} as const;

export const HOMEPAGE_TABS = {
  heroSection: "heroSection",
  quickLinks: "quickLinks",
  featuredGroups: "featuredGroups",
  agencyDetails: "agencyDetails",
} as const;

export const CONTENT_PREFERENCES_TABS = {
  experiences: "experiences",
  blogs: "blogs",
  offers: "offers",
  customPages: "customPages",
} as const;

export const WEBSITESECTION_TABS = {
  testimonials: "testimonials",
  aboutUs: "aboutUs",
  contactUs: "contactUs",
  ourPartners: "ourPartners",
  experiences: "experiences",
  tours: "tours",
  offers: "offers",
  blogs: "blogs",
  bookNow: "bookNow",
  unsubscribePage: "unsubscribePage",
  agentApplication: "agentApplication",
  customPage: "customPage",
  searchPage: "searchPage",
} as const;

export type SettingKey = (typeof SETTINGS_GALAXY)[keyof typeof SETTINGS_GALAXY];
export type HomePageTabKey = (typeof HOMEPAGE_TABS)[keyof typeof HOMEPAGE_TABS];
export type WebsiteSectionTabKey = (typeof WEBSITESECTION_TABS)[keyof typeof WEBSITESECTION_TABS];
export type ContentPreferenceTabKey = (typeof CONTENT_PREFERENCES_TABS)[keyof typeof CONTENT_PREFERENCES_TABS];

export const MAX_FAVICON_SIZE = 25600;

export const PROVINCES = [
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NT", label: "Northwest Territories" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon" },
];

export const PROVICE_MAPPING = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NT: "Northwest Territories",
  NS: "Nova Scotia",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
};

export const CLIENT_ACCOUNT_TYPES = { 0: "Leisure", 1: "Corporate", 3: "Group", 4: "Prospect", 6: "Lead" };
export const CLIENT_PROFILE_TYPES = { 0: "Client", 1: "Passenger" };

// Free Fields
export const CLIENT_FREE_FIELDS = {
  dietaryRestrictions: {
    id: 33,
    description: "Dietary Restrictions",
  },
  allergies: {
    id: 34,
    description: "Allergies",
  },
  emergencyContactName: {
    id: 36,
    description: "Emergency Contact Name",
  },
  emergencyContactRelationship: {
    id: 37,
    description: "Emergency Contact Relationship",
  },
  emergencyContactPhone: {
    id: 38,
    description: "Emergency Contact Phone",
  },
  emergencyContactEmail: {
    id: 39,
    description: "Emergency Contact Email",
  },
  emergencyContactPreferredMethod: {
    id: 40,
    description: "Emergency Contact Preferred Method",
  },
  aeroplanNumber: {
    id: 44,
    description: "Aeroplan Number",
  },
  westjetNumber: {
    id: 45,
    description: "WestJet Rewards Number",
  },
  placeOfBirth: {
    id: 47,
    description: "Place of Birth",
  },
};

export const EMAIL_AND_PRINT_MARKETING_CODES = {
  "TTAND Email Marketing": [
    {
      code: 211,
      name: "E-Exotic Escapes",
    },
    {
      code: 209,
      name: "E-Enchanting Europe",
    },
    {
      code: 207,
      name: "E-Culinary Delights",
    },
    {
      code: 205,
      name: "E-Inspiring Journeys",
    },
    {
      code: 377,
      name: "E-Ocean & River Cruises",
    },
    {
      code: 527,
      name: "E-Family Adventures",
    },
    {
      code: 212,
      name: "E-Sun Destinations",
    },
    {
      code: 208,
      name: "E-Vacations of a Lifetime",
    },
    {
      code: 210,
      name: "E-World of Savings",
    },
    {
      code: 731,
      name: "E-US Getaways",
    },
  ],
  "TTAND Luxe Email Marketing": [
    {
      code: 732,
      name: "E-Luxe Emails",
    },
  ],
  "TTAND Print Marketing": [
    {
      code: 216,
      name: "Mag-Nauticus",
    },
    {
      code: 528,
      name: "Mag-Postcards",
    },
    {
      code: 372,
      name: "Mag-Luxury Travel",
    },
    {
      code: 633,
      name: "FLY - Lux Ocean",
      headerName: "FLY - Lux. Ocean",
    },
    {
      code: 634,
      name: "FLY - Contemp Ocean",
      headerName: "FLY - Contemp. Ocean",
    },
    {
      code: 635,
      name: "FLY - River",
    },
  ],
};

export const LUXE_MARKETING_CODES = EMAIL_AND_PRINT_MARKETING_CODES["TTAND Luxe Email Marketing"].map(
  (code) => `${code.code}`,
);

// Promotion/offer description caps differ by campaign type: the Luxe email template
// renders the description in a fixed-height (72px / 3-line) card that overflows past
// ~110 chars, while the standard template flows freely. Enforcing these at input keeps
// the admin's preview identical to what recipients receive (no silent server truncation).
export const CAMPAIGN_DESCRIPTION_MAX_LENGTH = {
  standard: 250,
  luxe: 110,
} as const;

// The Luxe template renders the promotion heading in a fixed-height (42px) cell that clips
// past ~40 chars; the standard template wraps freely, so its 80 is only a soft "ideal" guide.
export const CAMPAIGN_TITLE_MAX_LENGTH = {
  standard: 80,
  luxe: 40,
} as const;

export const isLuxeCampaignByCodes = (clMarketingCodes?: { value: string }[]) =>
  !!clMarketingCodes?.length && clMarketingCodes.every((code) => LUXE_MARKETING_CODES.includes(code.value));

export const getPromotionDescriptionMaxLength = (isLuxeCampaign: boolean) =>
  isLuxeCampaign ? CAMPAIGN_DESCRIPTION_MAX_LENGTH.luxe : CAMPAIGN_DESCRIPTION_MAX_LENGTH.standard;

export const getPromotionTitleMaxLength = (isLuxeCampaign: boolean) =>
  isLuxeCampaign ? CAMPAIGN_TITLE_MAX_LENGTH.luxe : CAMPAIGN_TITLE_MAX_LENGTH.standard;

export const LANGUAGES = {
  0: "English",
  1: "French",
  2: "Spanish",
  3: "Korean",
  4: "Simplified Chinese",
};

// products
export const PRODUCTS = {
  aironly: "Air Only",
  cruise: "Cruise",
  ecoadventure: "Eco Adventure",
  luxury: "Luxury",
  motorCoach: "Motor Coach",
  sunAndBeaches: "Sun & Beaches",
  tours: "Tours",
  wedding: "Weddings",
  groups: "Groups",
  families: "Families",
  couples: "Couples",
  glbtq: "GLBTQ",
  students: "Singles",
  singles: "Students",
};

// destination expertise
export const DESTINATIONS = {
  canada: "Canada",
  usa: "USA",
  caribbean: "Caribbean",
  california: "California",
  centralAmerica: "Central America",
  florida: "Florida",
  lasvegas: "Las Vegas",
  mexico: "Mexico",
  asia: "Asia",
  africa: "Africa",
  australia: "Australia",
  europe: "Europe",
  newzealand: "NewZealand",
  southAmerica: "South America",
};

// languages
export const AGENT_LANGUAGES = {
  ar: "Arabic",
  ch: "Chinese",
  en: "English",
  fr: "French",
  ge: "German",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  po: "Portuguese",
  pu: "Punjabi",
  ru: "Russian",
  sp: "Spanish",
};

export const ALL_PREFIXES = [
  {
    label: "Mr.",
    value: "Mr.",
  },
  {
    label: "Mrs.",
    value: "Mrs.",
  },
  {
    label: "Ms.",
    value: "Ms.",
  },
  {
    label: "Dr.",
    value: "Dr.",
  },
  {
    label: "Mstr",
    value: "Mstr",
  },
  {
    label: "Miss",
    value: "Miss",
  },
  {
    label: "INF",
    value: "INF",
  },
];

export const ALL_LANGUAGES = [
  {
    label: "English",
    value: "0",
  },
  {
    label: "French",
    value: "1",
  },
  {
    label: "Spanish",
    value: "2",
  },
  {
    label: "Korean",
    value: "3",
  },
  {
    label: "Simplified Chinese",
    value: "4",
  },
];

export const ALL_CARD_TYPES = [
  {
    label: "Credit Card",
    value: "0",
  },
  {
    label: "Frequent Flyer",
    value: "1",
  },
  {
    label: "Passport",
    value: "2",
  },
  {
    label: "Other",
    value: "3",
  },
];

export const ALL_CODES = [
  {
    header: "TTAND Email Marketing",
    marketingItems: [
      {
        codeId: 211,
        codeType: 0,
        category: "TTAND",
        description: "E-Exotic Escapes",
        code: "",
        ranking: 1,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 209,
        codeType: 0,
        category: "TTAND",
        description: "E-Enchanting Europe",
        code: "",
        ranking: 2,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 207,
        codeType: 0,
        category: "TTAND",
        description: "E-Culinary Delights",
        code: "",
        ranking: 3,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 205,
        codeType: 0,
        category: "TTAND",
        description: "E-Inspiring Journeys",
        code: "",
        ranking: 4,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 377,
        codeType: 0,
        category: "TTAND",
        description: "E-Ocean & River Cruises",
        code: "",
        ranking: 5,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 527,
        codeType: 0,
        category: "TTAND",
        description: "E-Family Adventures",
        code: "",
        ranking: 6,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 212,
        codeType: 0,
        category: "TTAND",
        description: "E-Sun Destinations",
        code: "",
        ranking: 7,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 208,
        codeType: 0,
        category: "TTAND",
        description: "E-Vacations of a Lifetime",
        code: "",
        ranking: 8,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 210,
        codeType: 0,
        category: "TTAND",
        description: "E-World of Savings",
        code: "",
        ranking: 9,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
  {
    header: "TTAND Print Marketing",
    marketingItems: [
      {
        codeId: 216,
        codeType: 0,
        category: "TTAND",
        description: "Mag-Nauticus",
        code: "",
        ranking: 11,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 528,
        codeType: 0,
        category: "TTAND",
        description: "Mag-Postcards",
        code: "",
        ranking: 12,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 372,
        codeType: 0,
        category: "TTAND",
        description: "Mag-Luxury Travel",
        code: "",
        ranking: 13,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      // {
      //   codeId: 608,
      //   codeType: 0,
      //   category: 'TTAND',
      //   description: 'Flyer-Westjet',
      //   code: '',
      //   ranking: 15,
      //   flags: 0,
      //   clientCodes: null,
      //   action: 3
      // },

      // {
      //   codeId: 609,
      //   codeType: 0,
      //   category: 'TTAND',
      //   description: 'Flyer-NCL',
      //   code: '',
      //   ranking: 16,
      //   flags: 0,
      //   clientCodes: null,
      //   action: 3
      // },

      // {
      //   codeId: 610,
      //   codeType: 0,
      //   category: 'TTAND',
      //   description: 'Flyer-Celebrity',
      //   code: '',
      //   ranking: 17,
      //   flags: 0,
      //   clientCodes: null,
      //   action: 3
      // },

      // {
      //   codeId: 611,
      //   codeType: 0,
      //   category: 'TTAND',
      //   description: 'Flyer-RCi',
      //   code: '',
      //   ranking: 18,
      //   flags: 0,
      //   clientCodes: null,
      //   action: 3
      // },

      // {
      //   codeId: 612,
      //   codeType: 0,
      //   category: 'TTAND',
      //   description: 'Flyer-Ama Waterways',
      //   code: '',
      //   ranking: 19,
      //   flags: 0,
      //   clientCodes: null,
      //   action: 3
      // },
      // {
      //   codeId: 613,
      //   codeType: 0,
      //   category: 'TTAND',
      //   description: 'Flyer-Oceania',
      //   code: '',
      //   ranking: 20,
      //   flags: 0,
      //   clientCodes: null,
      //   action: 3
      // },
      {
        codeId: 633,
        codeType: 0,
        category: "TTAND",
        description: "FLY - Lux. Ocean",
        code: "",
        ranking: 20,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 634,
        codeType: 0,
        category: "TTAND",
        description: "FLY - Contemp. Ocean",
        code: "",
        ranking: 20,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 635,
        codeType: 0,
        category: "TTAND",
        description: "FLY - River",
        code: "",
        ranking: 20,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
  // {
  //   header: 'TTAND SME  PROGRAM',
  //   marketingItems: [
  //     {
  //       codeId: 480,
  //       codeType: 0,
  //       category: 'TTAND SME  PROGRAM',
  //       description: 'SME-Railbookers',
  //       code: null,
  //       ranking: 1,
  //       flags: 0,
  //       clientCodes: null,
  //       action: 3
  //     },
  //     {
  //       codeId: 481,
  //       codeType: 0,
  //       category: 'TTAND SME  PROGRAM',
  //       description: 'SME-Hurtigruten',
  //       code: null,
  //       ranking: 2,
  //       flags: 0,
  //       clientCodes: null,
  //       action: 3
  //     }
  //   ]
  // },
  {
    header: "Allergies",
    marketingItems: [
      {
        codeId: 485,
        codeType: 0,
        category: "Allergies",
        description: "Peanuts",
        code: null,
        ranking: 1,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 484,
        codeType: 0,
        category: "Allergies",
        description: "Soy",
        code: null,
        ranking: 2,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 483,
        codeType: 0,
        category: "Allergies",
        description: "Nuts",
        code: null,
        ranking: 3,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 488,
        codeType: 0,
        category: "Allergies",
        description: "Stone Fruit",
        code: null,
        ranking: 4,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 487,
        codeType: 0,
        category: "Allergies",
        description: "Chocolate",
        code: null,
        ranking: 5,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 486,
        codeType: 0,
        category: "Allergies",
        description: "melons",
        code: null,
        ranking: 6,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 496,
        codeType: 0,
        category: "Allergies",
        description: "Bees",
        code: null,
        ranking: 7,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 495,
        codeType: 0,
        category: "Allergies",
        description: "Wasps",
        code: null,
        ranking: 8,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 494,
        codeType: 0,
        category: "Allergies",
        description: "Gluten",
        code: null,
        ranking: 9,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 493,
        codeType: 0,
        category: "Allergies",
        description: "lactose",
        code: null,
        ranking: 10,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 492,
        codeType: 0,
        category: "Allergies",
        description: "Dust",
        code: null,
        ranking: 11,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 491,
        codeType: 0,
        category: "Allergies",
        description: "seafood",
        code: null,
        ranking: 12,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 490,
        codeType: 0,
        category: "Allergies",
        description: "Shellfish",
        code: null,
        ranking: 13,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 489,
        codeType: 0,
        category: "Allergies",
        description: "Fish",
        code: null,
        ranking: 14,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 498,
        codeType: 0,
        category: "Allergies",
        description: "eggs",
        code: null,
        ranking: 15,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 497,
        codeType: 0,
        category: "Allergies",
        description: "Sesame",
        code: null,
        ranking: 16,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
  {
    header: "INTERESTS",
    marketingItems: [
      {
        codeId: 21,
        codeType: 0,
        category: "INTERESTS",
        description: "COACH TOURS",
        code: "",
        ranking: 1,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 22,
        codeType: 0,
        category: "INTERESTS",
        description: "COUPLES",
        code: "",
        ranking: 2,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 23,
        codeType: 0,
        category: "INTERESTS",
        description: "CRUISES",
        code: "",
        ranking: 3,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 185,
        codeType: 0,
        category: "INTERESTS",
        description: "CRUISES-RIVER",
        code: "",
        ranking: 4,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 24,
        codeType: 0,
        category: "INTERESTS",
        description: "FAMILY VACATIONS",
        code: "",
        ranking: 5,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 25,
        codeType: 0,
        category: "INTERESTS",
        description: "GAMBLING",
        code: "",
        ranking: 6,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 26,
        codeType: 0,
        category: "INTERESTS",
        description: "GAY TRAVEL",
        code: "",
        ranking: 7,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 27,
        codeType: 0,
        category: "INTERESTS",
        description: "HEALTH SPAS",
        code: "",
        ranking: 8,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 28,
        codeType: 0,
        category: "INTERESTS",
        description: "INCLUSIVE PKGS",
        code: "",
        ranking: 9,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 29,
        codeType: 0,
        category: "INTERESTS",
        description: "RAIL TRAVEL",
        code: "",
        ranking: 10,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 30,
        codeType: 0,
        category: "INTERESTS",
        description: "ROMANTIC",
        code: "",
        ranking: 11,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 31,
        codeType: 0,
        category: "INTERESTS",
        description: "SENIOR\u0027S TRAVEL",
        code: "",
        ranking: 12,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 32,
        codeType: 0,
        category: "INTERESTS",
        description: "SHOW TOURS",
        code: "",
        ranking: 13,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 33,
        codeType: 0,
        category: "INTERESTS",
        description: "THEATRE",
        code: "",
        ranking: 14,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 34,
        codeType: 0,
        category: "INTERESTS",
        description: "THEME PARKS",
        code: "",
        ranking: 15,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 35,
        codeType: 0,
        category: "INTERESTS",
        description: "VFR",
        code: "",
        ranking: 16,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 349,
        codeType: 0,
        category: "INTERESTS",
        description: "SOLO Traveller",
        code: "",
        ranking: 17,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 408,
        codeType: 0,
        category: "INTERESTS",
        description: "Accessible Travel",
        code: "",
        ranking: 18,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 451,
        codeType: 0,
        category: "INTERESTS",
        description: "Faith Based Travel",
        code: "",
        ranking: 19,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 450,
        codeType: 0,
        category: "INTERESTS",
        description: "Women\u0027s Travel",
        code: "",
        ranking: 20,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
  {
    header: "DIETARY",
    marketingItems: [
      {
        codeId: 397,
        codeType: 0,
        category: "DIETARY",
        description: "Celiac",
        code: "",
        ranking: 1,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 396,
        codeType: 0,
        category: "DIETARY",
        description: "Plant based whole foods",
        code: "",
        ranking: 2,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 395,
        codeType: 0,
        category: "DIETARY",
        description: "Gluten free",
        code: "",
        ranking: 3,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 393,
        codeType: 0,
        category: "DIETARY",
        description: "Vegan",
        code: "",
        ranking: 4,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 392,
        codeType: 0,
        category: "DIETARY",
        description: "Kosher",
        code: "",
        ranking: 5,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 391,
        codeType: 0,
        category: "DIETARY",
        description: "Halal",
        code: "",
        ranking: 6,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 398,
        codeType: 0,
        category: "DIETARY",
        description: "Vegetarian-Non Dairy",
        code: "",
        ranking: 7,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 400,
        codeType: 0,
        category: "DIETARY",
        description: "Vegetarian-Lacto Ovo",
        code: "",
        ranking: 8,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 401,
        codeType: 0,
        category: "DIETARY",
        description: "Diabetic",
        code: "",
        ranking: 9,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 402,
        codeType: 0,
        category: "DIETARY",
        description: "Food Allergies",
        code: "",
        ranking: 10,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
  {
    header: "DESTINATIONS",
    marketingItems: [
      {
        codeId: 2,
        codeType: 0,
        category: "DESTINATIONS",
        description: "AFRICA",
        code: "",
        ranking: 1,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 3,
        codeType: 0,
        category: "DESTINATIONS",
        description: "ALASKA",
        code: "",
        ranking: 2,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 4,
        codeType: 0,
        category: "DESTINATIONS",
        description: "ASIA",
        code: "",
        ranking: 3,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 5,
        codeType: 0,
        category: "DESTINATIONS",
        description: "AUSTRALIA",
        code: "",
        ranking: 4,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 176,
        codeType: 0,
        category: "DESTINATIONS",
        description: "BRAZIL",
        code: "",
        ranking: 5,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 6,
        codeType: 0,
        category: "DESTINATIONS",
        description: "CALIFORNIA",
        code: "",
        ranking: 6,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 7,
        codeType: 0,
        category: "DESTINATIONS",
        description: "CANADA",
        code: "",
        ranking: 7,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 8,
        codeType: 0,
        category: "DESTINATIONS",
        description: "CARIBBEAN",
        code: "",
        ranking: 8,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 9,
        codeType: 0,
        category: "DESTINATIONS",
        description: "EUROPE",
        code: "",
        ranking: 9,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 10,
        codeType: 0,
        category: "DESTINATIONS",
        description: "FLORIDA",
        code: "",
        ranking: 10,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 177,
        codeType: 0,
        category: "DESTINATIONS",
        description: "FRANCE",
        code: "",
        ranking: 11,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 178,
        codeType: 0,
        category: "DESTINATIONS",
        description: "GERMANY",
        code: "",
        ranking: 12,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 179,
        codeType: 0,
        category: "DESTINATIONS",
        description: "GREECE",
        code: "",
        ranking: 13,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 11,
        codeType: 0,
        category: "DESTINATIONS",
        description: "HAWAII",
        code: "",
        ranking: 14,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 180,
        codeType: 0,
        category: "DESTINATIONS",
        description: "INDIA",
        code: "",
        ranking: 15,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 12,
        codeType: 0,
        category: "DESTINATIONS",
        description: "ISRAEL",
        code: "",
        ranking: 16,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 181,
        codeType: 0,
        category: "DESTINATIONS",
        description: "JAPAN",
        code: "",
        ranking: 17,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 13,
        codeType: 0,
        category: "DESTINATIONS",
        description: "MEXICO",
        code: "",
        ranking: 18,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 14,
        codeType: 0,
        category: "DESTINATIONS",
        description: "MIDDLE EAST",
        code: "",
        ranking: 19,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 15,
        codeType: 0,
        category: "DESTINATIONS",
        description: "NEVADA",
        code: "",
        ranking: 20,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 16,
        codeType: 0,
        category: "DESTINATIONS",
        description: "NEW YORK",
        code: "",
        ranking: 21,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 182,
        codeType: 0,
        category: "DESTINATIONS",
        description: "NEW ZEALAND",
        code: "",
        ranking: 22,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 183,
        codeType: 0,
        category: "DESTINATIONS",
        description: "SOUTH AFRICA",
        code: "",
        ranking: 23,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 17,
        codeType: 0,
        category: "DESTINATIONS",
        description: "SOUTH AMERICA",
        code: "",
        ranking: 24,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 184,
        codeType: 0,
        category: "DESTINATIONS",
        description: "THAILAND",
        code: "",
        ranking: 25,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 18,
        codeType: 0,
        category: "DESTINATIONS",
        description: "UNITED KINGDOM",
        code: "",
        ranking: 26,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 19,
        codeType: 0,
        category: "DESTINATIONS",
        description: "UNITED STATES",
        code: "",
        ranking: 27,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
  {
    header: "SPORTS",
    marketingItems: [
      {
        codeId: 37,
        codeType: 0,
        category: "SPORTS",
        description: "ATHLETICS",
        code: "",
        ranking: 1,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 38,
        codeType: 0,
        category: "SPORTS",
        description: "BASEBALL",
        code: "",
        ranking: 2,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 39,
        codeType: 0,
        category: "SPORTS",
        description: "BODY BUILDING",
        code: "",
        ranking: 3,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 186,
        codeType: 0,
        category: "SPORTS",
        description: "CRICKET",
        code: "",
        ranking: 4,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 40,
        codeType: 0,
        category: "SPORTS",
        description: "FOOTBALL",
        code: "",
        ranking: 5,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 41,
        codeType: 0,
        category: "SPORTS",
        description: "GOLF",
        code: "",
        ranking: 6,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 187,
        codeType: 0,
        category: "SPORTS",
        description: "GYMNASTICS",
        code: "",
        ranking: 7,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 42,
        codeType: 0,
        category: "SPORTS",
        description: "HOCKEY",
        code: "",
        ranking: 8,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 188,
        codeType: 0,
        category: "SPORTS",
        description: "LACROSS",
        code: "",
        ranking: 9,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 43,
        codeType: 0,
        category: "SPORTS",
        description: "OLYMPICS",
        code: "",
        ranking: 10,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 44,
        codeType: 0,
        category: "SPORTS",
        description: "SAILING",
        code: "",
        ranking: 11,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 45,
        codeType: 0,
        category: "SPORTS",
        description: "SCUBA",
        code: "",
        ranking: 12,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 46,
        codeType: 0,
        category: "SPORTS",
        description: "SKIING",
        code: "",
        ranking: 13,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 47,
        codeType: 0,
        category: "SPORTS",
        description: "SOCCER",
        code: "",
        ranking: 14,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 48,
        codeType: 0,
        category: "SPORTS",
        description: "SURFING",
        code: "",
        ranking: 15,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 49,
        codeType: 0,
        category: "SPORTS",
        description: "SWIMMING",
        code: "",
        ranking: 16,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 50,
        codeType: 0,
        category: "SPORTS",
        description: "TENNIS",
        code: "",
        ranking: 17,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 51,
        codeType: 0,
        category: "SPORTS",
        description: "WIND SURFING",
        code: "",
        ranking: 18,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
      {
        codeId: 52,
        codeType: 0,
        category: "SPORTS",
        description: "WRESTLING",
        code: "",
        ranking: 19,
        flags: 0,
        clientCodes: null,
        action: 3,
      },
    ],
  },
];

export const TTAND_S3_PREFIX = `https://s3.amazonaws.com/ttand`;

export const FORM_LANGUAGES = {
  en: {
    ariaLabel: "English",
    label: "EN",
    value: "en",
  },
  fr: {
    ariaLabel: "French",
    label: "FR",
    value: "fr",
  },
};

export const RISING_STAR_LEVELS = {
  "1": 7500,
  "2": 15000,
  "3": 30000,
  "4": 50000,
  "5": 70000,
  "6": 115000,
  "7": 160000,
  "8": 205000,
  "9": 250000,
  "10": 300000,
  "11": 350000,
  "12": 400000,
  "13": 450000,
} as const;

// all currency codes
export const ALL_CURRENCIES = [
  { label: "🇺🇸 USD", value: "USD" },
  { label: "🇪🇺 EUR", value: "EUR" },
  { label: "🇯🇵 JPY", value: "JPY" },
  { label: "🇬🇧 GBP", value: "GBP" },
  { label: "🇦🇺 AUD", value: "AUD" },
  { label: "🇨🇦 CAD", value: "CAD" },
  { label: "🇨🇭 CHF", value: "CHF" },
  { label: "🇨🇳 CNY", value: "CNY" },
  { label: "🇸🇪 SEK", value: "SEK" },
  { label: "🇳🇿 NZD", value: "NZD" },
  { label: "🇲🇽 MXN", value: "MXN" },
  { label: "🇸🇬 SGD", value: "SGD" },
  { label: "🇭🇰 HKD", value: "HKD" },
  { label: "🇳🇴 NOK", value: "NOK" },
  { label: "🇰🇷 KRW", value: "KRW" },
  { label: "🇹🇷 TRY", value: "TRY" },
  { label: "🇮🇳 INR", value: "INR" },
  { label: "🇷🇺 RUB", value: "RUB" },
  { label: "🇿🇦 ZAR", value: "ZAR" },
  { label: "🇧🇷 BRL", value: "BRL" },
  { label: "🇵🇱 PLN", value: "PLN" },
  { label: "🇩🇰 DKK", value: "DKK" },
  { label: "🇹🇭 THB", value: "THB" },
  { label: "🇮🇩 IDR", value: "IDR" },
  { label: "🇮🇱 ILS", value: "ILS" },
  { label: "🇸🇦 SAR", value: "SAR" },
  { label: "🇦🇪 AED", value: "AED" },
  { label: "🇨🇱 CLP", value: "CLP" },
  { label: "🇨🇴 COP", value: "COP" },
  { label: "🇨🇿 CZK", value: "CZK" },
  { label: "🇭🇺 HUF", value: "HUF" },
  { label: "🇮🇸 ISK", value: "ISK" },
  { label: "🇷🇴 RON", value: "RON" },
  { label: "🇦🇷 ARS", value: "ARS" },
  { label: "🇲🇾 MYR", value: "MYR" },
  { label: "🇵🇭 PHP", value: "PHP" },
  { label: "🇺🇦 UAH", value: "UAH" },
  { label: "🇻🇳 VND", value: "VND" },
  { label: "🇪🇬 EGP", value: "EGP" },
  { label: "🇰🇼 KWD", value: "KWD" },
  { label: "🇵🇪 PEN", value: "PEN" },
  { label: "🇶🇦 QAR", value: "QAR" },
  { label: "🇴🇲 OMR", value: "OMR" },
  { label: "🇨🇷 CRC", value: "CRC" },
  { label: "🇩🇴 DOP", value: "DOP" },
  { label: "🇺🇾 UYU", value: "UYU" },
  { label: "🇬🇹 GTQ", value: "GTQ" },
  { label: "🇵🇦 PAB", value: "PAB" },
  { label: "🇧🇭 BHD", value: "BHD" },
  { label: "🇧🇴 BOB", value: "BOB" },
  { label: "🇸🇻 SVC", value: "SVC" },
  { label: "🇭🇳 HNL", value: "HNL" },
  { label: "🇳🇮 NIO", value: "NIO" },
  { label: "🇵🇾 PYG", value: "PYG" },
  { label: "🇹🇹 TTD", value: "TTD" },
  { label: "🇧🇧 BBD", value: "BBD" },
  { label: "🇫🇯 FJD", value: "FJD" },
  { label: "🇬🇾 GYD", value: "GYD" },
  { label: "🇯🇲 JMD", value: "JMD" },
  { label: "🇸🇷 SRD", value: "SRD" },
  { label: "🇧🇸 BSD", value: "BSD" },
  { label: "🇧🇿 BZD", value: "BZD" },
  { label: "🇰🇾 KYD", value: "KYD" },
  { label: "🇦🇮 XCD", value: "XCD" },
  { label: "🇧🇲 BMD", value: "BMD" },
];

export const ALL_CURRENCIES_TEXT = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "JPY", value: "JPY" },
  { label: "GBP", value: "GBP" },
  { label: "AUD", value: "AUD" },
  { label: "CAD", value: "CAD" },
  { label: "CHF", value: "CHF" },
  { label: "CNY", value: "CNY" },
  { label: "SEK", value: "SEK" },
  { label: "NZD", value: "NZD" },
  { label: "MXN", value: "MXN" },
  { label: "SGD", value: "SGD" },
  { label: "HKD", value: "HKD" },
  { label: "NOK", value: "NOK" },
  { label: "KRW", value: "KRW" },
  { label: "TRY", value: "TRY" },
  { label: "INR", value: "INR" },
  { label: "RUB", value: "RUB" },
  { label: "ZAR", value: "ZAR" },
  { label: "BRL", value: "BRL" },
  { label: "PLN", value: "PLN" },
  { label: "DKK", value: "DKK" },
  { label: "THB", value: "THB" },
  { label: "IDR", value: "IDR" },
  { label: "ILS", value: "ILS" },
  { label: "SAR", value: "SAR" },
  { label: "AED", value: "AED" },
  { label: "CLP", value: "CLP" },
  { label: "COP", value: "COP" },
  { label: "CZK", value: "CZK" },
  { label: "HUF", value: "HUF" },
  { label: "ISK", value: "ISK" },
  { label: "RON", value: "RON" },
  { label: "ARS", value: "ARS" },
  { label: "MYR", value: "MYR" },
  { label: "PHP", value: "PHP" },
  { label: "UAH", value: "UAH" },
  { label: "VND", value: "VND" },
  { label: "EGP", value: "EGP" },
  { label: "KWD", value: "KWD" },
  { label: "PEN", value: "PEN" },
  { label: "QAR", value: "QAR" },
  { label: "OMR", value: "OMR" },
  { label: "CRC", value: "CRC" },
  { label: "DOP", value: "DOP" },
  { label: "UYU", value: "UYU" },
  { label: "GTQ", value: "GTQ" },
  { label: "PAB", value: "PAB" },
  { label: "BHD", value: "BHD" },
  { label: "BOB", value: "BOB" },
  { label: "SVC", value: "SVC" },
  { label: "HNL", value: "HNL" },
  { label: "NIO", value: "NIO" },
  { label: "PYG", value: "PYG" },
  { label: "TTD", value: "TTD" },
  { label: "BBD", value: "BBD" },
  { label: "FJD", value: "FJD" },
  { label: "GYD", value: "GYD" },
  { label: "JMD", value: "JMD" },
  { label: "SRD", value: "SRD" },
  { label: "BSD", value: "BSD" },
  { label: "BZD", value: "BZD" },
  { label: "KYD", value: "KYD" },
  { label: "XCD", value: "XCD" },
  { label: "BMD", value: "BMD" },
];

// trip info
export const TRIP_STATUSES = {
  1: {
    name: "Active",
    bgColor: "#dcfce7",
    color: "#16a34a",
  },
  2: {
    name: "Draft",
    bgColor: "#fee2e2",
    color: "#dc2626",
  },
};

export const TRAVEL_TYPES = {
  "10": {
    name: "Air",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: FlightTakeoffOutlinedIcon,
  },
  "11": {
    name: "Car",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "12": {
    name: "Hotel",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "13": {
    name: "Cruise",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "14": {
    name: "Tour",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "15": {
    name: "Rail",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "16": {
    name: "Insurance",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "17": {
    name: "Fee",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "18": {
    name: "Transportation",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "19": {
    name: "Misc",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
  "30": {
    name: "Miscellaneous",
    bgColor: "primary.100",
    color: "primary.500",
    Icon: HotelOutlinedIcon,
  },
};

/** Day-of-month ranges, in calendar order. An endDay of null runs to the last day of the month. */
export const PAY_PERIODS: { startDay: number; endDay: number | null }[] = [
  { startDay: 1, endDay: 15 },
  { startDay: 16, endDay: null },
];

export const RESERVATION_STATUS_CANCELLED = 2;

export const RESERVATION_STATUSES = {
  0: {
    name: "Active",
    bgColor: "#dcfce7",
    color: "#16a34a",
  },
  1: { name: "Quote", bgColor: "#fee2e2", color: "#dc2626" },
  2: { name: "Cancelled", bgColor: "#fee2e2", color: "#dc2626" },
  3: { name: "Hold", bgColor: "#fee2e2", color: "#dc2626" },
  4: { name: "Group Master", bgColor: "#fee2e2", color: "#dc2626" },
  5: { name: "Pending", bgColor: "#fee2e2", color: "#dc2626" },
  6: { name: "Adjustment", bgColor: "#fee2e2", color: "#dc2626" },
  7: { name: "Void", bgColor: "#fee2e2", color: "#dc2626" },
  8: { name: "Tour Master", bgColor: "#fee2e2", color: "#dc2626" },
  9: { name: "Wait List", bgColor: "#fee2e2", color: "#dc2626" },
  10: { name: "Closed", bgColor: "#fee2e2", color: "#dc2626" },
  11: { name: "Tour Master Set Up", bgColor: "#fee2e2", color: "#dc2626" },
};

// 100, 600
export const MESSAGE_STATUSES = {
  0: {
    name: "Pending",
    bgColor: "#fef3c7",
    color: "#d97706",
  },
  1: {
    name: "Completed",
    bgColor: "#dcfce7",
    color: "#16a34a",
  },
  2: {
    name: "Updated",
    bgColor: "#dbeafe",
    color: "#2563eb",
  },
};

export const ALLOCATION_STATUSES = {
  ALLOCATED: {
    name: "Allocated",
    bgColor: "#dcfce7",
    color: "#16a34a",
  },
  CANCELLED: {
    name: "Cancelled",
    bgColor: "#fee2e2",
    color: "#dc2626",
  },
};

export const MESSAGE_TYPES = {
  5: "Important",
  0: "Appointment",
  1: "Reminder",
  2: "Task",
  3: "Note",
  4: "Phone Call",
  6: "Quote",
  7: "Alert",
  8: "QC Alert",
  9: "Accounting",
  10: "Issue",
  11: "Campaign Email",
  12: "Client Profile Email",
  13: "Instant Message",
  14: "Email",
};

export const MESSAGE_PRIORITY_TYPES = {
  0: {
    name: "Low",
    bgColor: "#e2e8f0",
    color: "#1e293b",
  },
  5: {
    name: "Low",
    bgColor: "#e2e8f0",
    color: "#1e293b",
  },
  1: {
    name: "High",
    bgColor: "#fee2e2",
    color: "#dc2626",
  },
  8: {
    name: "High",
    bgColor: "#fee2e2",
    color: "#dc2626",
  },
};

export const TTAND_BRAND_NAME = "The Travel Agent Next Door";

export const DEFAULT_STANDARD_COMMENTS = [
  {
    title: "Standard Terms",
    description: `<p> <strong>Basic Terms</strong> <br> #MyAgencyName arranges travel services with independent third parties, such as airlines, transfer companies, baggage handlers, cruise lines, hotels and other independent suppliers to provide you and others listed on this Form, with the travel services purchased. #MyAgencyName exercises care in selecting these independent suppliers and pays particular attention to their reputation and reliability.  However, #MyAgencyName does not control these independent suppliers and cannot be held responsible for their performance or lack thereof.  #MyAgencyName is not responsible for any injury, loss or damage whether mental, emotional or physical howsoever sustained, resulting or arising from any error, omission or negligence of any company or person, agent, employee or sub-contractor supplying any of these travel services.  #MyAgencyName is not responsible for consequential damages or special damages suffered by you or others listed on this Form, even in circumstances in which #MyAgencyName is aware of the reason you or others listed on the Form are using the travel services, including circumstances in which you or others listed on the Form arrive at a destination later than expected and/or are unable to use any travel services on the Form, whether the travel service is included in the price or not.  Neither you nor others listed on this Form shall have any claim against #MyAgencyName by reason of you or others listed on this Form failing to purchase travel insurance or because you failed to advise others listed on the Form to purchase travel insurance.</p><p> <strong>Limitation of Agent Liability</strong> <br> #MyAgencyName’s liability for any loss, damage or injury, whether to property, physical or mental, arising from its own acts, omissions or negligence, is limited to the amount paid by you or others listed on this Form, in relation to which any claim by you or others listed on this Form, is made.</p><p> <strong>Travel Services</strong> <br> All travel services are subject to the terms and conditions imposed by the supplier of the travel services, including airlines, hotels, restaurants, places of entertainment, tour operators.  These travel services are subject to charges and/or restrictions for any changes or cancellation. Refunds, in whole or in part, for unused travel services are subject to the terms and conditions of those suppliers. #MyAgencyName shall only be responsible for refunding the net amount recovered from the travel service supplier, less amounts expended to provide alternate services and its other related expenses. You acknowledge that you or others listed on this Form may be required to provide credit card information to the supplier directly to confirm the reservation.  Charges processed by a supplier will appear on your or others listed on this Form credit card statement. All costs including fares, taxes, and surcharges are subject to change without notice until full payment is received by #MyAgencyName.  Price increases are permitted unless booking is paid in full. If the total price of the travel service is increased and the cumulative increase, except any increase resulting from an increase in retail sales tax or federal goods and services tax, is more than 7 percent, you have the choice of a full refund or comparable alternate travel services. (TICO-Ontario). Your Receipt/Invoice may include charges from #MyAgencyName for administration fees which are non-refundable. Additional fees and/or restrictions may apply to reservation changes and/or cancellations.</p><p> <strong>Collection Personal Information</strong> <br> #MyAgencyName may, from time to time, collect personal information about you as result of your relationship with us. #MyAgencyName may collect, use and disclose such personal information to determine your eligibility for and interest in products and services from #MyAgencyName, its affiliates or carefully selected third party business partners. We may also use this information to establish, maintain and manage your relationship with #MyAgencyName and to provide you with ongoing services and for other uses as set by our Privacy Policy. As you do business with #MyAgencyName, we may monitor and/or record your telephone conversations with our customer service representatives to ensure service quality. #MyAgencyName retains your personal information only as long as required for our reasonable business and/or legal needs.</p><p> <strong>Travellers Obligations</strong> <br> You confirm being at least 18 years old and legally capable of requesting #MyAgencyName to make a booking for the travel services for you and other others listed on this Form. <br> You agree to provide a copy of these Terms and Conditions, and any changes to them, to others listed on this Form before paying for this booking. <br> You acknowledge that you and the others listed on this Form, have been directed to review the terms and conditions of the suppliers of the travel services listed on this Form, including including airlines, hotels, restaurants, places of entertainment, tour operators, including baggage allowances, check-in times, and advised that any questions you and others listed on this Form have about the travel suppliers’ terms and conditions should be addressed to the specific travel service supplier. <br> You and others listed on this Form, are responsible for ensuring that they have all necessary travel documentation, including a passport (valid until 6 months after the expected return date), visas, parental consents to travel with minors required by any destination to which they are travelling or through which they will transit and pardons with respect to any criminal conviction. <br> You and others listed on this Form, acknowledge that even with possession of the required documentation and information s/he may be refused entry into a country at either the point of departure or arrival. <br> You and others listed on this Form, acknowledge that the destination(s) to which they are travelling may have living standards and practices and standards and conditions with respect to the provision of utilities, services and accommodation, that may differ from what they are used to at home. <br> You are responsible for notifying #MyAgencyName of any special requirements regarding the travel arrangements, including the type of seating/accommodation required and dietary requirements of you and others listed on this Form, at the time of completing this Form.  #MyAgencyName will make travel suppliers aware of such requests and you shall be responsible for any additional costs for such requests, however #MyAgencyName shall not be responsible for any failure by the travel suppliers to provide such services. <br> You acknowledge that a credit card is required for each room at the time of check in at a hotel and a preauthorized amount will be held by the credit card company in favour of the hotel until check out to cover any damages and/or incidental amounts charged by you or others listed on this Form during the stay.  You also acknowledge that failure to present a valid credit card and permit the preauthorized amount to be charged to the credit card will result in the reservation being cancelled by the hotel.' +
    '#MyAgencyName shall not be liable for any damage or loss suffered by you or others listed in this Form, including the inability to use any of the travel services, as a result of failing to comply with any of the obligations in this section.</p>`,
  },
  // {
  //   title: `Covid-19 Terms & Conditions`,
  //   description: `<p>BY SIGNING THIS DOCUMENT, I, &nbsp;#ClientName, ACKNOWLEDGE that I, and everyone who is a part of the booking I am going to make with &nbsp;#MyAgencyName is waiving certain rights and I acknowledge, for myself and everyone who is part of the booking, that:</p>\n<ul>\n    <li>Covid 19 is active, worldwide, with associated health risks and restrictions that could, without warning, affect and cause significant disruptions, cancellations and changes to any and all travel arrangements, by way of Covid 19 outbreaks, sudden border closures, quarantine and lockdown orders, airport closures, government travel advisories, return-home directives, hospitalisation for treatment and other similar consequences; and consequences not reasonably foreseeable at &nbsp;this time (collectively referred to as the &ldquo;Covid 19 Risks&rdquo;);</li>\n    <li>I/We, who is a part of the booking have had professional advice as to personal health condition and medical needs and I warrant that I/We, who is a part of this booking is fit to travel; and</li>\n    <li>Any travel insurance policy obtained by me or anyone else who is a part of the booking, may not include insurance coverage for travel service cancellations, interruptions financial, medical or other Covid 19 Risks, and all types of coverage must be confirmed with the travel insurer.&nbsp;</li>\n</ul>\n<p>NOTWITHSTANDING THE ABOVE, I/We, who is a part of the booking, have decided to proceed with the travel arrangements that I am asking #MyAgencyName to book for me/us and I/we agree that:</p>\n<ul>\n    <li>By going ahead with the travel arrangements, I/we voluntarily assume all the Covid 19 Risks and other risks involved with such travel, whether those risks are expected or unexpected;</li>\n    <li>In the event that some or all of the travel arrangements are cancelled, interrupted or otherwise affected by the Covid 19 Risks, my/our rights and remedies shall be as determined and limited by the cancellation, rebooking, refund and other policies and the terms and conditions of the supplier of the affected travel service, as set out in its brochures and/or websites, all of which have been referred to me by #MyAgencyName;</li>\n    <li>In no circumstances will the #MyAgencyName, its employees, directors, contractors, and agents, be liable to me/us, or any other person, for any refund, loss, damage, delay or injury resulting from any cancellation, interruption, or other event or a failure of any supplier to provide any travel service to me/us, or for any other breach of contract or the intentional or careless act or omission of any supplier of any such travel service;</li>\n    <li>I/we hereby waive all and any rights or claims that I/we, our heirs, assigns or any other person may have against #MyAgencyName arising directly or indirectly from the occurrence of any Covid 19 Risks, or the failure, whether negligent or otherwise, of #MyAgencyName to inform of any Covid 19 Risks or precautions to take or required documents;&nbsp;</li>\n    <li>I/We, understand that it is my responsibility to check the latest travel information regarding this virus outbreak with the CDC. https://wwwnc.cdc.gov/travel/notices</li>\n    <li>I/We am/are aware that additional screening procedures and restrictions may take place at airports and in public areas. I/We am/are aware that these restrictions may include mandatory face coverings and/or temperature checks in airports, hotels, cruise ships, trains or other means of transport.</li>\n    <li>I/We am/are aware that Immigration restrictions may be put in place before or during my travels that may impede my ability to enter or exit the destination as planned.&nbsp;</li>\n    <li>I/We, understand that it is my responsibility to have travel insurance to ensure I have coverage for all medical needs and trip cancellation, but understand that concerns or fear of travel is not a covered reason for cancellation relating to the Coronavirus/ Covid-19 and will be denied.&nbsp;</li>\n    <li>In case I/We, don&rsquo;t purchase insurance, I hold #MyAgencyName harmless for my decision to not purchase travel insurance for any denial of claim by travel insurer as it relates to Covid-19 or any other claim under the policy.&nbsp;</li>\n    <li>I/We, understand that I am bound by the terms and conditions of the insurance policy as it is related to Covid19.</li>\n</ul>\n<p>Travel insurance generally only covers unforeseen events. Most insurers classified COVID-19 as a &apos;known event&apos; late January 2020. Please note that most policies have a specific clause stating they do not cover epidemics and pandemics, especially when travel warnings are in place.&nbsp;</p>\n<ul>\n    <li>I/We, hold #MyAgencyName harmless for any travel restrictions, death, illness, cancellations by suppliers, hotels, airlines, cruise lines, tour agencies or any other travel provider, financial loss, quarantining rules or measures put in place at airports or destinations I am traveling through.</li>\n    <li>I/We, further agree to hold #MyAgencyName harmless for any financial penalties or fees imposed by the suppliers, hotels, airlines, cruise lines, tour agencies or any other travel provider due to cancellations or postponements due to Covid19 and agree not to institute a credit card dispute or &ldquo;chargeback&rdquo; to #MyAgencyName for said penalties or fees.&nbsp;</li>\n    <li>I/We, am/are aware that it is my personal decision to travel and is doing so with full knowledge of current travel recommendations and travel restrictions with regards to the Coronavirus COVID-19 and takes full responsibility for my actions with regards to this.</li>\n    <li>This waiver and release of liability is in addition to the terms and conditions of the #MyAgencyName and the terms and conditions of the suppliers providing the travel services that are part of the booking.</li>\n    <li>If any part of this waiver and release of liability is found to be unenforceable that will not affect the enforceability of any other part, each of which is severable from any unenforceable part.</li>\n</ul>`,
  // },
];

// referrals
// 100 & 500
export const REFERRALS_BEST_TIME_TO_CONTACT = {
  Afternoon: {
    bgcolor: "#fef3c7",
    color: "#f59e0b",
  },
  Morning: {
    bgcolor: "#e0f2fe",
    color: "#0ea5e9",
  },
  Evening: {
    bgcolor: "#ffedd5",
    color: "#f97316",
  },
  "No Preference": {
    bgcolor: "#f3f4f6",
    color: "#6b7280",
  },
};

// 100 & 500
export const REFERRALS_PREFERRED_WAY = {
  Email: {
    bgcolor: "#DBEAFE",
    color: "#3B82F6",
  },
  Phone: {
    bgcolor: "#D1FAE5",
    color: "#10B981",
  },
  Both: {
    bgcolor: "#EDE9FE",
    color: "#8B5CF6",
  },
  Telephone: {
    bgcolor: "#fce7f3",
    color: "#ec4899",
  },
  "E-mail": {
    bgcolor: "#DBEAFE",
    color: "#3B82F6",
  },
  "No Preference": {
    bgcolor: "#F3F4F6",
    color: "#6B7280",
  },
};

// 100 & 500
export const REFERRALS_AGENT_TYPE = {
  "New to Industry": {
    bgcolor: "#ecfccb",
    color: "#84cc16",
  },
  Experienced: {
    bgcolor: "#ffe4e6",
    color: "#f43f5e",
  },
};

export const CLIENT_BULK_UPLOAD_SAMPLE_SHEET = `https://s3.amazonaws.com/ttand/uploads/common/clients-sample-new-1753795213923.xlsx`;
export const PASSENGER_BULK_UPLOAD_SAMPLE_SHEET = `https://s3.amazonaws.com/ttand/uploads/common/passengers-sample-new-1753795229390.xlsx`;

// column added to the downloaded failed-rows sheet; dropped again when that sheet is re-uploaded
export const BULK_UPLOAD_REASON_COLUMN = "Reason";

export const QUICK_ACTIONS = [
  {
    id: "ttand-university",
    text: "TTAND University",
    Icon: SchoolOutlinedIcon,
    link: "https://learn.ttand.org/",
    external: true,
  },
  {
    id: "email",
    text: "Email",
    Icon: DraftsOutlinedIcon,
    link: "https://outlook.office365.com/",
    external: true,
  },
  {
    id: "clientlinq",
    text: "ClientLinq",
    Icon: DnsOutlinedIcon,
    link: "https://ttand.travcomone.com/ttand/Default.aspx",
    external: true,
  },
  {
    id: "sirev",
    text: "Sirev",
    Icon: DraftsOutlinedIcon,
    link: "http://www.sirev.com",
    external: true,
  },
  {
    id: "manulife",
    text: "Manulife",
    Icon: DraftsOutlinedIcon,
    link: "https://www.manulifetravel.ca/",
    external: true,
  },
  {
    id: "sherpa",
    text: "Travel Restrictions (Sherpa)",
    Icon: GridViewOutlinedIcon,
    link: "https://apply.joinsherpa.com/travel-restrictions",
    external: true,
  },
  {
    id: "travel-leaders",
    text: "Travel Leaders Network",
    Icon: GridViewOutlinedIcon,
    link: "/portals/travel-leaders",
  },
];

// magazine mapping
export const MAGAZINE_MAILERS_MAPPING = {
  NA: 0,
  0: 0,
  1: 10,
  2: 15,
  3: 20,
  4: 25,
  5: 30,
  6: 35,
  7: 40,
  8: 45,
  9: 50,
  10: 55,
  11: 60,
  12: 65,
  13: 70,
} as Record<string, number>;

export const ENQUIRE_FULL_AMOUNT = "ENQUIRE_FULL_AMOUNT";
export const ENQUIRE_MIN_DEPOSIT = "ENQUIRE_MIN_DEPOSIT";
export const PAY_MIN_DEPOSIT = "PAY_MIN_DEPOSIT";
export const PAY_FULL_AMOUNT = "PAY_FULL_AMOUNT";

export const BOOKING_ENGINES: Record<string, string> = {
  allInclusiveWebsiteURL: "All Inclusive",
  cruisesWebsiteURL: "Cruises",
  riverCruisesWebsiteURL: "River Cruises",
  airWebsiteURL: "Air Only",
  carsWebsiteURL: "Cars",
  packagesWebsiteURL: "Packages",
  hotelsWebsiteURL: "Hotels",
  activityWebsiteURL: "Activities",
  insuranceWebsiteURL: "Insurance",
  safetravelWebsiteURL: "Ship",
  excursionsWebsiteURL: "Excursions",
  assuranceWebsiteURL: "Travel Health",
};

export const FIT_TRIP_LOGO_URL = "https://s3.amazonaws.com/ttand/uploads/common/2026-fit-trip-logo-1780906611499.svg";
export const PROMOTION_DESCRIPTION_LIMIT = 500;

// Conference Archive -> All Attendees
// Hardcoded, not fetched. Empty selection means "no year filter", so a year missing here can
// never hide rows -- only means you can't filter down to it.
export const CONFERENCE_ARCHIVE_YEARS = [2026, 2025, 2024, 2023, 2022, 2021];

export const CONFERENCE_ARCHIVE_YEAR_OPTIONS: OptionObj[] = CONFERENCE_ARCHIVE_YEARS.map((year) => ({
  label: `${year}`,
  value: `${year}`,
}));

export const CONFERENCE_ATTENDEE_TYPE_OPTIONS: OptionObj[] = [
  { label: "Agent", value: "AGENT" },
  { label: "Supplier", value: "SUPPLIER" },
  { label: "Staff", value: "STAFF" },
  { label: "Speaker", value: "SPEAKER" },
  { label: "Media", value: "MEDIA" },
  { label: "Other", value: "OTHER" },
];

export const CONFERENCE_ARCHIVE_STATUS_OPTIONS: OptionObj[] = [
  { label: "Confirmed", value: "CONFIRMED" },
  { label: "Waitlisted", value: "WAITLISTED" },
  { label: "Cancelled", value: "CANCELLED" },
];

// Conference Archive -> Invoices
// Scoped to the current + prior two conferences, though CONFERENCE invoices exist for 2027 too --
// reachable by clearing the Year filter, since empty means "no year filter".
export const CONFERENCE_INVOICE_YEARS = [2026, 2025, 2024];

export const CONFERENCE_INVOICE_YEAR_OPTIONS: OptionObj[] = CONFERENCE_INVOICE_YEARS.map((year) => ({
  label: `${year}`,
  value: `${year}`,
}));

export const CONFERENCE_INVOICE_STATUS_OPTIONS: OptionObj[] = [
  { label: "Paid", value: "PAID" },
  { label: "Unpaid", value: "UNPAID" },
  { label: "Refunded", value: "REFUNDED" },
];

export const CONFERENCE_BOOKING_TYPE_OPTIONS: OptionObj[] = [
  { label: "Package", value: "PACKAGE" },
  { label: "Hotel Only", value: "HOTEL" },
  { label: "None", value: "NONE" },
];
